import React, { useEffect, useState, FC } from "react";
import qs from 'qs'

import style from "./index.module.scss";

import { Tabs, Tag, Pagination, ConfigProvider, Spin } from 'antd';
import zhCN from 'antd/es/locale/zh_CN'

const { TabPane } = Tabs;

export interface IAppProps {
  apiHost: string;
  loginHost: string;
}
let _host = "";
let _loginHost = "";

//顶部大图
const ImgTop: FC<any> = (props) => {
  const { topImgList } = props;
  return (
    <div className={style.topImgWrap}>
      {topImgList &&
        topImgList.map((item: any) => {
          return (
            <div key={item.title} className={style.bacImgWrap} style={{ backgroundImage: `url(${item.backUrl})` }}>
              <div className={style.mainContentWrap}>
                <div className={style.title}>{item.title}</div>
                <div className={style.subTitle}>{item.subTitle}</div>
              </div>
            </div>
          )
        })
      }
    </div>
  );
};

//列表
const MainList: FC<any> = () => {
  const [abilityType, setAbilityType] = useState('');
  const [loading, setLoading] = useState(false);
  const [totalSize, setTotalSize] = useState();
  const [curPage, setCurPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [abilityInfoList, setAbilityInfoList] = useState([]);
  const [abilityTypeList, setAbilityTypeList] = useState([]);
  const fetchList = (abilityType: any, curPage: any, pageSize: any) => {
    setLoading(true)
    fetch(_host + `/ability/list?${abilityType?'abilityType='+abilityType: ''}`+ "&curPage=" + curPage + "&pageSize=" + pageSize, {
      method: "POST",
      credentials: "include",
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (res) {
        const { code, data, success } = res;
        // console.log(res);
        if (data && code === 100000 && success) {
          setAbilityInfoList(data.abilityInfoList);
          setAbilityTypeList(data.abilityTypeList);
          setTotalSize(data.totalSize);
        }
        setLoading(false)
      })
      .catch(function () {
        setLoading(false)
        console.log("失败了");
      })
  };

  const clickTab = (key: any) => {
    setAbilityType(key);
    location.href = location.href.split('?')[0] + '?abilityType=' + key;
  }

  const pageChange = (page: any, pageSize: any) => {
    setCurPage(page);
    setPageSize(pageSize);
    fetchList(abilityType, page, pageSize);
  }


  useEffect(() => {
    const param:any = qs.parse(location.href.split('?')[1]);
    // console.log(param, '-------')
    if(param.abilityType) {
      setAbilityType(param.abilityType);
    } else {
      setAbilityType('');
    }
    fetchList(param.abilityType, curPage, pageSize);
  }, [])

  return (
    <Spin spinning={loading}>
      <div className={style.listWrap}>
      <div className={style.mainContentWrap}>
        {abilityTypeList && abilityTypeList.length > 0 ?
          <Tabs onChange={clickTab} type="card" activeKey={abilityType}>
            <TabPane tab="全部" key="">
              {abilityInfoList && abilityInfoList.map((c: any, index: number) => {
                return (
                  <a className={style.item} key={c.id} href={`/powercenterdetail?abilityId=${c.id}`} target="_blank">
                    <div className={style.itemIcon}>
                      <img src={c.iconLink} />
                    </div>
                    <div className={style.itemCon}>
                      <div className={style.itemTitle}>
                        {c.abilityName}
                        {c.abilityTypeList && c.abilityTypeList.length > 0 && c.abilityTypeList.map((tag: any) => {
                          return (
                            index % 3 === 0 ? <Tag color="blue" key={tag.id}>{tag.abilityName}</Tag> : (index % 3 === 1 ? <Tag color="purple" key={tag.id}>{tag.abilityName}</Tag> : <Tag color="cyan" key={tag.id}>{tag.abilityName}</Tag>)
                          )
                        })}
                      </div>
                      <div className={style.itemDesc}>{c.description}</div>
                    </div>
                  </a>
                )
              })}
              <ConfigProvider locale={zhCN}>
                <Pagination
                  onChange={pageChange}
                  total={totalSize}
                  pageSizeOptions={['10', '20', '50', '100']}
                  showSizeChanger
                  showQuickJumper
                  current={curPage}
                  showTotal={total => `共 ${total} 条`}
                />
              </ConfigProvider>
            </TabPane>
            {abilityTypeList &&
              abilityTypeList.map((item: any) => {
                return (
                  <TabPane tab={item.abilityName} key={item.id}>
                    {abilityInfoList && abilityInfoList.map((c: any, index: number) => {
                      return (
                        <a className={style.item} key={c.id} href={`/powercenterdetail?abilityId=${c.id}`}>
                          <div className={style.itemIcon}>
                            <img src={c.iconLink} />
                          </div>
                          <div className={style.itemCon}>
                            <div className={style.itemTitle}>
                              {c.abilityName}
                              {c.abilityTypeList && c.abilityTypeList.length > 0 && c.abilityTypeList.map((tag: any) => {
                                return (
                                  index % 3 === 0 ? <Tag color="blue" key={tag.id}>{tag.abilityName}</Tag> : (index % 3 === 1 ? <Tag color="purple" key={tag.id}>{tag.abilityName}</Tag> : <Tag color="cyan" key={tag.id}>{tag.abilityName}</Tag>)
                                )
                              })}
                            </div>
                            <div className={style.itemDesc}>{c.description}</div>
                          </div>
                        </a>
                      )
                    })}
                    <ConfigProvider locale={zhCN}>
                      <Pagination
                        onChange={pageChange}
                        total={totalSize}
                        pageSizeOptions={['10', '20', '50', '100']}
                        showSizeChanger
                        showQuickJumper
                        current={curPage}
                        showTotal={total => `共 ${total} 条`}
                      />
                    </ConfigProvider>
                  </TabPane>
                )
              })
            }
          </Tabs> :
          <div className={style.empty}>{
            !loading ? '暂无数据哦~': null
          }</div>
        }
      </div>
    </div>
    </Spin>
  );
};

const App: React.FC<IAppProps> = props => {
  const { apiHost, loginHost } = props;
  const baseUrl = "//storage.360buyimg.com/hishop-images/jos-home-img/";
  _host = apiHost;
  _loginHost = loginHost;

  //顶部大图
  const topImgList = [
    {
      key: 1,
      title: '能力中心',
      subTitle: '提供多场景优质能力，帮助开发者提升效率',
      backUrl: `${baseUrl}top.png`,
    },
  ];

  return (
    <div className={style.app}>
      {/* 顶部大图 */}
      <ImgTop topImgList={topImgList}></ImgTop>
      <MainList></MainList>
    </div>
  );
};

export default App;
